import React, { useEffect, useState } from "react";
import {
  format,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  addWeeks,
  addMonths,
  subWeeks,
  subMonths,
  eachDayOfInterval,
  isSameDay,
} from "date-fns";
import "./Shifts.scss";
import axios from "axios";
import { BASE_API_URL } from "../../utils/consts";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as ArrowIcon } from "../../assets/images/icons/arrowLeft.svg";
import { useTranslation } from "react-i18next";
import { ReactComponent as AddIcon } from "../../assets/images/icons/plusCircle.svg";
import { ReactComponent as ShiftEmployeeIcon } from "../../assets/images/icons/shiftEmployee.svg";
import AddShiftModal from "../../Components/Modals/AddShiftModal/AddShiftModal";
import { ShiftAbbreviation, ShiftType } from "./utils";
import { Button, Popover } from "antd";
import { setLoader } from "../../utils/redux/slices/loaderSlice";
interface Shift {
  _id: string;
  userId: string;
  clientId: string;
  date: string;
  startTime: string;
  endTime: string;
  shiftType: string;
  durationInHours: number;
}

interface User {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  clientId: string;
  avatar: {
    url: string;
  };
  shifts: Shift[];
}

interface ShiftSchedulerProps {
  //   users: User[];
}

const ShiftScheduler: React.FC<ShiftSchedulerProps> = () => {
  const { t } = useTranslation();
  const [view, setView] = useState<"week" | "month">("week");
  const [currentDate, setCurrentDate] = useState(new Date());
  const userData = useSelector((state: any) => state.userData.user);
  const [users, setUsers] = useState<any>(undefined);
  const [shiftModalOpen, setShiftModalOpen] = useState<any>(undefined);
  const dispatch = useDispatch();
  const getFormattedDate = (date: Date) => {
    return format(date, "yyyy-MM-dd"); // Local time, 'YYYY-MM-DD'
  };

  // Calculate dynamic date range based on currentDate and view
  const fromDate = getFormattedDate(
    view === "week"
      ? startOfWeek(currentDate, { weekStartsOn: 1 }) // Week starts on Monday
      : startOfMonth(currentDate)
  );

  const baseDate =
    view === "week"
      ? startOfWeek(currentDate, { weekStartsOn: 1 }) // Ponedeljak je prvi dan u nedelji
      : startOfMonth(currentDate);

  const fromDateISO = baseDate.toISOString();

  const toDate = getFormattedDate(
    view === "week"
      ? endOfWeek(currentDate, { weekStartsOn: 1 })
      : endOfMonth(currentDate)
  );

  const baseToDate =
    view === "week"
      ? endOfWeek(currentDate, { weekStartsOn: 1 })
      : endOfMonth(currentDate);

  const toDateISO = baseToDate.toISOString();
  useEffect(() => {
    if (userData.clientId) {
      dispatch(setLoader(true));
      axios
        .get(
          `${BASE_API_URL}/users-with-shifts/${userData.clientId}?from=${fromDate}&to=${toDate}`
        )
        .then((res) => {
          setUsers(res.data.data);
          // You can handle the users and shifts here if needed
        })
        .catch((err) => console.error(err))
        .finally(() => dispatch(setLoader(false)));
    }
  }, [userData.clientId, currentDate, view]);

  const handlePrev = () => {
    setCurrentDate(
      view === "week" ? subWeeks(currentDate, 1) : subMonths(currentDate, 1)
    );
  };

  const handleNext = () => {
    setCurrentDate(
      view === "week" ? addWeeks(currentDate, 1) : addMonths(currentDate, 1)
    );
  };

  console.log("userData", userData);
  const getVisibleDates = () => {
    if (view === "week") {
      const start = startOfWeek(currentDate, { weekStartsOn: 1 }); // Monday
      const end = endOfWeek(currentDate, { weekStartsOn: 1 });
      return eachDayOfInterval({ start, end });
    } else {
      const start = startOfMonth(currentDate);
      const end = endOfMonth(currentDate);
      return eachDayOfInterval({ start, end });
    }
  };

  function formatTimeToHHMM(dateString: any) {
    const date = new Date(dateString);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  const addShift = (value: any) => {
    console.log("value", value);
    if (value.isMultipleShift) {
      axios
        .post(`${BASE_API_URL}/create-multiple-shifts`, {
          userId: shiftModalOpen.user._id,
          clientId: userData.clientId,
          startDate: new Date(value.date).toISOString(),
          shiftStartTime: formatTimeToHHMM(value.startTime),
          shiftEndTime: formatTimeToHHMM(value.endTime),
          shiftType: value.shiftType,
          timeFrame: value.timeFrame,
          excludeDays: value.excludedWeekDays,
          customExcludeDates: value.excludedDates,
        })
        .then((res) => {
          console.log("res", res);
          setShiftModalOpen(undefined);
          if (userData.clientId) {
            dispatch(setLoader(true));
            axios
              .get(
                `${BASE_API_URL}/users-with-shifts/${userData.clientId}?from=${fromDate}&to=${toDate}`
              )
              .then((res) => {
                setUsers(res.data.data);
                // You can handle the users and shifts here if needed
              })
              .catch((err) => console.error(err))
              .finally(() => dispatch(setLoader(false)));
          }
          //   setUsers(res.data.data);
          // You can handle the users and shifts here if needed
        })
        .catch((err) => console.error(err));
    } else {
      axios
        .post(`${BASE_API_URL}/shifts/create`, {
          userId: shiftModalOpen.user._id,
          clientId: userData.clientId,
          date: value.date,
          startTime: value.startTime,
          endTime: value.endTime,
          shiftType: value.shiftType,
        })
        .then((res) => {
          console.log("res", res);
          setShiftModalOpen(undefined);
          if (userData.clientId) {
            dispatch(setLoader(true));
            axios
              .get(
                `${BASE_API_URL}/users-with-shifts/${userData.clientId}?from=${fromDate}&to=${toDate}`
              )
              .then((res) => {
                setUsers(res.data.data);
                // You can handle the users and shifts here if needed
              })
              .catch((err) => console.error(err))
              .finally(() => dispatch(setLoader(false)));
          }
          //   setUsers(res.data.data);
          // You can handle the users and shifts here if needed
        })
        .catch((err) => console.error(err));
    }
  };

  const visibleDates = getVisibleDates();

  function formatTime(time: any) {
    // Ako je ISO format, parsiraj i vrati HH:mm
    const isoDate = Date.parse(time);
    if (!isNaN(isoDate)) {
      const date = new Date(time);
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    }

    // Inače vrati direktno (pretpostavlja se da je u HH:mm formatu)
    return time;
  }

  function colorToRgba(color: string, alpha: number = 0.1): string {
    const dummy = document.createElement("div");
    dummy.style.color = color;
    document.body.appendChild(dummy);

    const computedColor = getComputedStyle(dummy).color;
    document.body.removeChild(dummy);

    const rgbMatch = computedColor.match(/^rgb\((\d+), (\d+), (\d+)\)$/);
    if (rgbMatch) {
      const [_, r, g, b] = rgbMatch;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    // fallback
    return `rgba(0, 0, 0, ${alpha})`;
  }

  const getInitials = (firstName?: string, lastName?: string) => {
    if (!firstName && !lastName) return "";
    return ((firstName?.[0] ?? "") + (lastName?.[0] ?? "")).toUpperCase();
  };

  function formatDuration(duration: number): string | number {
    const decimalPart = duration.toString().split(".")[1];
    if (decimalPart && decimalPart.length >= 2) {
      return duration.toFixed(1);
    }
    return duration;
  }

  const deleteShift = (shift: any) => {
    axios.delete(`${BASE_API_URL}/shifts/delete?shiftId=${shift._id}`)
      .then((res) => {
        console.log("API: ${BASE_API_URL}/shifts?shiftId=${shift._id}/delete")
        if (userData.clientId) {
          dispatch(setLoader(true));
          axios
            .get(
              `${BASE_API_URL}/users-with-shifts/${userData.clientId}?from=${fromDate}&to=${toDate}`
            )
            .then((res) => {
              setUsers(res.data.data);
              // You can handle the users and shifts here if needed
            })
            .catch((err) => console.error(err))
            .finally(() => dispatch(setLoader(false)));
        }
      })
      .catch(() => console.log("error"));
  };

  const deleteMultipleShifts = (shift: any) => {
    const startDate = startOfMonth(shift.date);
    const endDate = endOfMonth(shift.date);
    console.log("starrrr", startDate, endDate);
    axios
      .delete(
        `${BASE_API_URL}/shifts/delete?unitId=${shift?.unitId}&dateFrom=${startDate}&dateTo=${endDate}`
      )
      .then((res) => {
        if (userData.clientId) {
          dispatch(setLoader(true));
          axios
            .get(
              `${BASE_API_URL}/users-with-shifts/${userData.clientId}?from=${fromDate}&to=${toDate}`
            )
            .then((res) => {
              setUsers(res.data.data);
              // You can handle the users and shifts here if needed
            })
            .catch((err) => console.error(err))
            .finally(() => dispatch(setLoader(false)));
        }
      })
      .catch(() => console.log("error"));
  };
  console.log("users", users);
  return (
    <div className="shift-scheduler">
      {/* Header */}
      <div className="scheduler-header">
        <div className="period">
          <label>Period</label>
          <div className="selectDate">
            <button onClick={handlePrev}>
              <ArrowIcon />
            </button>
            <h2>
              {view === "week"
                ? `${format(
                  startOfWeek(currentDate, { weekStartsOn: 1 }),
                  "MMM d"
                )} - ${format(
                  endOfWeek(currentDate, { weekStartsOn: 1 }),
                  "MMM d, yyyy"
                )}`
                : `${format(currentDate, "MMMM yyyy")}`}
            </h2>
            <button onClick={handleNext} className="nextBtn">
              <ArrowIcon />
            </button>
          </div>
        </div>
        <div className="viewType">
          <label>{t("View Type")}</label>
          <div>
            <button
              onClick={() => setView("week")}
              className={`${view === "week" ? "active" : ""}`}
            >
              {t("Week")}
            </button>
            <button
              onClick={() => setView("month")}
              className={`${view === "month" ? "active" : ""}`}
            >
              {t("Month")}
            </button>
          </div>
        </div>
      </div>

      {/* Grid Layout */}
      <div className="scheduler-grid">
        {/* Header Row (Days) */}
        <div className="grid-row grid-header">
          <div className="grid-cell employee-header">
            <ShiftEmployeeIcon />
          </div>
          <div className="dates-header">
            {visibleDates.map((date) => (
              <div key={date.toISOString()} className="grid-cell date-header">
                <div>{t(format(date, "EEEEEE"))}</div>
                <div>{format(date, "d")}</div>
              </div>
            ))}
          </div>
        </div>

        {/* User Rows */}
        {users?.map((user: any) => {
          return (
            <div key={user._id} className="grid-row">
              <div className="grid-cell employee-name">
                {/* <div className="initials-circle">
                  {getInitials(user.user.firstName, user.user.lastName)}
                </div> */}
                <div className="userInformation">
                  {user.user.firstName} {user.user.lastName}
                  <span
                    data-fulltext={user?.user?.position}
                    style={{
                      color: user?.user?.color ?? "rgb(0 0 0 / 100%)",
                      background:
                        colorToRgba(user.user.color, 0.1) ?? "rgb(0 0 0 / 10%)",
                    }}
                  >
                    {user?.user?.position}
                  </span>
                </div>
              </div>
              <div className="dates-row">
                {visibleDates.map((dateStr, index) => {
                  const date = new Date(dateStr); // Converting the string to Date object
                  // Find all shifts for the current user on the specific date
                  const shiftsForDate = user.shifts.filter((shift: any) => {
                    const shiftDate = new Date(shift.date); // Convert shift date to Date object
                    // Compare the two dates while ignoring the time part (just compare the day)
                    return isSameDay(date, shiftDate);
                  });

                  return (
                    <div key={index} className="grid-cell shift-data">
                      {shiftsForDate.length > 0
                        ? shiftsForDate.map((shift: any, i: number) => {
                          const shiftSingle: { shiftType: ShiftType } = {
                            shiftType: shift.shiftType,
                          };

                          return (
                            <Popover
                              content={
                                <div className="deleteShifts">
                                  <Button onClick={() => deleteShift(shift)}>
                                    {t("Delete shift")}
                                  </Button>
                                  <br />
                                  {shift?.unitId && (
                                    <Button
                                      onClick={() =>
                                        deleteMultipleShifts(shift)
                                      }
                                    >
                                      {t("Delete multiple shifts")}
                                    </Button>
                                  )}
                                </div>
                              }
                              // title="Title"
                              trigger="click"
                            >
                              <div
                                className={`shift ${view}`}
                                key={i}
                                onClick={() => console.log("click", shift)}
                                style={{
                                  border: `2px solid ${user?.user?.color ?? "grey"
                                    }`,
                                  margin: 4,
                                  backgroundColor: user?.user?.color
                                    ? `rgba(${parseInt(
                                      user?.user?.color.slice(1, 3),
                                      16
                                    )}, ${parseInt(
                                      user?.user?.color.slice(3, 5),
                                      16
                                    )}, ${parseInt(
                                      user?.user?.color.slice(5, 7),
                                      16
                                    )}, 0.5)` // Adjust opacity here
                                    : "rgba(128, 128, 128, 0.1)", // Default grey background with opacity
                                }}
                              >
                                {/* {format(new Date(shift.date), "dd-MM")}{" "} */}
                                {/* Date */}
                                <div className="shiftBody">
                                  {view === "week" ? (
                                    <div className="shiftDate">
                                      <div>
                                        {" "}
                                        <span>
                                          {formatTime(shift.startTime)}
                                        </span>{" "}
                                        <i>-</i>{" "}
                                        <span>
                                          {" "}
                                          {formatTime(shift.endTime)}
                                        </span>
                                      </div>
                                      <span>
                                        {formatDuration(
                                          shift.durationInHours
                                        )}
                                        h
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="shiftDate">
                                      {formatTime(shift.startTime)}
                                      <br />
                                      {formatTime(shift.endTime)}
                                      {/* <span>{shift.durationInHours}h</span> */}
                                    </div>
                                  )}
                                  <Popover
                                    content={
                                      <div
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        {shift.shiftType}
                                      </div>
                                    }
                                    title={
                                      <div
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        {t("Shift Info")}
                                      </div>
                                    }
                                    placement="top"
                                  >
                                    <div
                                      className="shiftType"
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      {
                                        ShiftAbbreviation[
                                        shiftSingle.shiftType
                                        ]
                                      }
                                    </div>
                                  </Popover>
                                </div>
                                {/* Shift details */}
                              </div>
                            </Popover>
                          );
                        })
                        : "-"}
                      <div
                        className="addShift"
                        onClick={() =>
                          setShiftModalOpen({
                            user: user.user,
                            date: dateStr,
                            shift: shiftsForDate,
                          })
                        }
                      >
                        <AddIcon />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      {shiftModalOpen && (
        <AddShiftModal
          isOpen={shiftModalOpen}
          onCloseModal={() => setShiftModalOpen(undefined)}
          onAddShift={(value: any) => {
            addShift(value);
          }}
          shiftModalOpen={shiftModalOpen}
        />
      )}
    </div>
  );
};

export default ShiftScheduler;
